import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";

const gridLocation = 'productList';

@observer
export default class ProductList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.product;
  static title = loc.i18n`Products`;
  static icon = 'cube';
  static rootPage = true;
  static protectedPage = true;

  static fetchData(routerParams) {
    console.log("ProductList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
    });
  }

  render() {
    let {params, query} = this.props;


    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           multiUpdateSecurable={SECURABLE.productGridUpdate} >
          <ZzFlatButtonRoute onGridToolbar routeName="productDetail" params={{id: 'new'}} label={loc.i18n`New Product`} permission={PERMISSION.New} securable={PAGE.productDetail}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/product/page/productList.tsx